import { render, staticRenderFns } from "./t-dialog-support.vue?vue&type=template&id=1accc604&"
import script from "./t-dialog-support.vue?vue&type=script&lang=js&"
export * from "./t-dialog-support.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports